import script from "./profile_check.vue?vue&type=script&setup=true&lang=ts"
export * from "./profile_check.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__